import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Button} from 'antd';
import {StyledOverviewRightPanel} from './StyledOverviewRightPanel';
import SpendingDetails from '../SpendingDetails';
import {expenseActions} from '../../../../state/actions/expense.actions';

const OverviewRightPanel = ({
  dispatch,
  isAdmin,
  spendingDetailProps = {},
  openExpenseAgentChat,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'subscriptions']);

  const handleNewClick = (variant) => ({
    'new-expense': openExpenseAgentChat,
  }[variant]?.());

  return (
    <StyledOverviewRightPanel
      className='w-100'
      direction='vertical'
      size='large'
      {...rest}
    >
      <Button
        onClick={() => handleNewClick('new-expense')}
        style={{ width: '100%' }}
        type='primary'
      >
        {t('new')} {t('expense')}
      </Button>
      <SpendingDetails {...spendingDetailProps} />
    </StyledOverviewRightPanel>
  );
}

const mapStateToProps = state => {
  const {isAdmin} = state.user;

  return {
    isAdmin,
  }
}

const mapDispatchToProps = {
  openExpenseAgentChat: expenseActions.openExpenseAgentChat
}

export default connect(mapStateToProps, mapDispatchToProps)(OverviewRightPanel);
